import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  deleteRestrictionIps,
  fetchRestrictionIps,
  reset,
  setPage,
  setSelectedIds,
  setSize,
} from 'features/restrictionIp/restrictionIpListSlice'
import RestrictionIpListView from 'features/restrictionIp/RestrictionIpListView'
import { success, fail } from 'features/toast/Toast'
import api from 'api/axios/foka'
import moment from 'moment'
import { downloadCsvFile } from 'utils'

const RestrictionIpList = () => {
  const dispatch = useDispatch()
  const { selectedIds, size, page } = useSelector(
    state => state.restrictionIp.restrictionIpList
  )

  useEffect(() => () => dispatch(reset()), [dispatch])

  useEffect(() => {
    dispatch(fetchRestrictionIps())
  }, [dispatch, size, page])

  const onConfirmDelete = async ({ isConfirmed }) => {
    if (isConfirmed) {
      const { error, payload } = await dispatch(
        deleteRestrictionIps(selectedIds)
      )
      if (error) {
        if (payload.errorCode === 404) {
          fail('해당 IP가 존재하지 않습니다.')
        } else if (payload.errorMessage) {
          fail(payload.errorMessage)
        } else {
          fail('삭제할 수 없습니다.')
        }
      } else {
        success('IP가 정상 삭제되었습니다.')
        dispatch(fetchRestrictionIps())
      }
    }
  }

  const handleCSVFileDownload = async () => {
    try {
      const response = await api.restrictionIp.getCsvString()
      downloadCsvFile(
        response.data,
        `노출제한IP관리_${moment().format('YYYY-MM-DD')}.csv`
      )
    } catch (e) {
      fail('알 수 없는 에러가 발생했습니다.')
    }
  }

  return (
    <RestrictionIpListView
      onConfirmDelete={onConfirmDelete}
      handlePageChange={newPage => dispatch(setPage(newPage))}
      onSelectionChange={ids => dispatch(setSelectedIds(ids))}
      handleSizeChange={v => dispatch(setSize(v))}
      handleCSVFileDownload={handleCSVFileDownload}
    />
  )
}

export default RestrictionIpList
